import Vue from 'vue'
import App from './App.vue'
import router from "@/router"
import store from "@/store"
//elementUI框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//网络请求
import { request, requestSys, baseUrl, baseImgUrl, uploadRequest } from "./request/index"
//添加功能函数
import * as utils from './utils'
//添加被动事件监听器
import 'default-passive-events';

//注册全局组件
import "./components/global/index"

//注册全局请求
Vue.prototype.$request = request
Vue.prototype.$requestSys = requestSys
// Vue.prototype.$requestSys = requestData
Vue.prototype.baseUrl = baseUrl
Vue.prototype.baseImgUrl = baseImgUrl
Vue.prototype.$uploadRequest = uploadRequest

// 注册全局功能函数
for (let key in utils) {
  Vue.prototype['$' + key] = utils[key]
}

Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

/**自定义插件 */
import Loading from "./plugins/Loding/index";
Vue.use(Loading)

Vue.config.productionTip = false

const vm = new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')

//导出vm实例
export default vm
